import React, { useEffect } from 'react'
import Spacing from '../../../componenets/UI/Spacing'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaPhone, FaSnapchatGhost, FaYoutube } from 'react-icons/fa'
import { FaLocationDot, FaXTwitter } from 'react-icons/fa6'
import { MdEmail } from 'react-icons/md'
import { TbWorldWww } from 'react-icons/tb'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import useSponsorsActions from '../hooks/useSponsorsActions'
import { useSponsorContext } from '../context/sponsor/SponsorProvider'
import LoaderSponsorDetailsPage from '../components/sponsor-details-page/LoaderSponsorDetailsPage'
import { sponsorAssetUrl } from '../data/staticSponsors'

export default function SponsorDetailsPage() {
  const { t } = useTranslation()
  const { lng } = useParams()
  const { sponsor_slug } = useParams()
  const { getSponsor } = useSponsorsActions()
  const { sponsorState } = useSponsorContext()

  useEffect(() => {
    getSponsor(sponsor_slug)
  }, [sponsor_slug])

  const sponsor = sponsorState.sponsor

  if (sponsorState.isLoading || !sponsor) {
    return <LoaderSponsorDetailsPage />
  }

  const sponsorPackage = sponsor.sponsor_package ?? sponsor.sponsorPackage
  const sponsorPackageName = sponsorPackage?.[`name_${lng}`] ?? t('SPONSORS')
  const descriptionTitle = sponsor[`description_title_${lng}`] ?? (sponsor.slug === 'jordan_phosphate_mines_company' ? t('COMPANY_DESCRIPTION') : t('DESCRIPTION'))

  return (
    <div className="app-container px-8 lg:px-0">
      <Helmet>
        <title>{`APFM | ${sponsorPackageName} : ${sponsor[`name_${lng}`]}`}</title>
      </Helmet>
      <Spacing />
      <div
        data-aos={`fade-down`}
        data-aos-delay={100}
        className="mb-4"
      >
        <h2 className="text-2xl font-black">{sponsorPackageName}</h2>
      </div>
      <div
        data-aos={`fade-up`}
        data-aos-delay={100}
      >
        <div>
          <div className="mb-16 flex flex-col border-2 border-muted-300 bg-light p-8 lg:flex-row">
            <div className="lg:ltr:border-r-2 lg:ltr:pr-8 lg:rtl:border-l-2 lg:rtl:pl-8">
              <img
                className={`!h-64 !w-64 object-contain ${sponsor.isStatic ? 'bg-dark p-6' : ''}`}
                src={sponsorAssetUrl(sponsor, 'logo')}
                alt={sponsor[`name_${lng}`]}
              />
            </div>
            <div className="lg:px-8">
              <h2 className="mb-8 text-3xl font-bold">{sponsor[`name_${lng}`]}</h2>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div>
                    <FaLocationDot />
                  </div>
                  <div>{sponsor.country?.[`name_${lng}`] ?? '--'}</div>
                </div>
                {(!sponsor.isStatic || sponsor.phone) && <div className="flex items-center gap-2">
                  <div>
                    <FaPhone />
                  </div>
                  <div dir="ltr">{sponsor.phone ?? '--'}</div>
                </div>}
                {(!sponsor.isStatic || sponsor.email) && <div className="flex items-center gap-2">
                  <div>
                    <MdEmail />
                  </div>
                  <div>{sponsor.email ?? '--'}</div>
                </div>}
                <div className="flex items-center gap-2">
                  <div>
                    <TbWorldWww />
                  </div>
                  {sponsor.website_url ? (
                    <Link
                      target="_blank"
                      to={sponsor.website_url}
                    >
                      {sponsor.website_url}
                    </Link>
                  ) : (
                    <div>--</div>
                  )}
                </div>
              </div>
              <div className="mt-8 flex gap-2">
                {sponsor.linkedin && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsor.linkedin}
                  >
                    <FaLinkedinIn />
                  </Link>
                )}
                {sponsor.x && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsor.x}
                  >
                    <FaXTwitter />
                  </Link>
                )}
                {sponsor.youtube && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsor.youtube}
                  >
                    <FaYoutube />
                  </Link>
                )}
                {sponsor.facebook && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsor.facebook}
                  >
                    <FaFacebookF />
                  </Link>
                )}
                {sponsor.snapchat && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsor.snapchat}
                  >
                    <FaSnapchatGhost />
                  </Link>
                )}
                {sponsor.instagram && (
                  <Link
                    target="_blank"
                    className="border-2 border-secondary-600 bg-secondary-600 p-2 text-white hover:border-secondary-600 hover:bg-muted-300 hover:text-secondary-600"
                    to={sponsor.instagram}
                  >
                    <FaInstagram />
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div>
            <h2 className="mb-4 text-2xl font-bold">{descriptionTitle}</h2>
            <article>
              <div
                className="text-justify"
                dangerouslySetInnerHTML={{
                  __html: sponsor[`description_${lng}`],
                }}
              />
            </article>
          </div>
        </div>
      </div>
    </div>
  )
}
